<template>
  <div style="padding: 0px 20px">
    <a-tabs :default-active-key="tabKey" @change="handleTabChange">
      <a-tab-pane v-for="item in tabPaneConfig" :key="item.key" :tab="item.tab">
        <TableList
          :columns="item.columns"
          :tableData="item.tableData"
          :loading="item.loading"
          :scroll="{}"
          :pagination="tabPaneConfig[item.key - 1].pagination"
          @change="handleTableChange"
          :attrs="
            item.key == 3
              ? {
                  rowKey: 'id',
                  rowSelection: { selectedRowKeys: selectedRowKeys, onChange: onSelectChange },
                }
              : {}
          "
        >
          <div slot="queryArea" style="margin-bottom: 20px">
            <div v-if="item.key == 1 || item.key == 2">
              <a-select
                v-model="queryParam.type"
                placeholder="请选择处理状态"
                style="width: 170px; margin-right: 15px"
                :options="item.key == 1 ? followOptions : classOptions"
                allowClear
              />
              <a-input-search
                v-if="item.key == 1 || item.key == 2"
                v-model="queryParam.name"
                placeholder="请输入学生名字"
                style="width: 170px; margin-right: 15px"
                @change="searchName"
              />
              <a-button type="primary" @click="queryTable">查询</a-button>
            </div>
            <div v-else-if="item.key === 3">
              <!-- <a-button type="primary" icon="plus">新增</a-button> -->
              <a-button type="primary" icon="download" style="margin: 0 15px" @click="exportXls">
                导出
              </a-button>
              <!-- <a-upload
                name="file"
                :showUploadList="false"
                :multiple="false"
                :headers="tokenHeader"
                :action="importExcelUrl"
                @change="handleImportExcel"
              >
                <a-button type="primary" icon="import">导入</a-button>
              </a-upload> -->
            </div>
          </div>
          <template slot="action" slot-scope="{ record }">
            <div class="action-detail" @click="handelDetail(record)">查看详情</div>
          </template>
        </TableList>
      </a-tab-pane>
    </a-tabs>
    <HandleDetailModal :detailList="detailModalData" ref="handleDetailModal" />
  </div>
</template>
<script>
import TableList from '@/components/chart/TableList'
import HandleDetailModal from './HandleDetailModal'
import { getAction } from '@api/manage'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import * as XLSX from 'xlsx'
import { simpleDebounce } from '@/utils/util'

const tablePagination = {
  current: 1,
  pageSize: 10,
  pageSizeOptions: ['10', '50', '100'],
  showTotal: (total, range) => {
    return range[0] + '-' + range[1] + ' 共' + total + '条'
  },
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
}

export default {
  name: 'CampusDynamic',
  mixins: [JeecgListMixin],
  components: {
    TableList,
    HandleDetailModal,
  },
  data() {
    return {
      tabKey: 1,
      queryParam: {
        // type: 0,
        // name: '',
      },
      selectedRowKeys: [],
      followOptions: [
        {
          value: 4,
          label: '未处理',
        },
        {
          value: 3,
          label: '已处理',
        },
      ],
      classOptions: [
        {
          value: 4,
          label: '未处理',
        },
        {
          value: 1,
          label: '已处理',
        },
      ],
      tabPaneConfig: [
        {
          tab: '心情提醒',
          key: 1,
          columns: [
            {
              title: '序号',
              dataIndex: 'index',
              align: 'center',
            },
            {
              title: '年级',
              dataIndex: 'gradeName',
              align: 'center',
            },
            {
              title: '班级',
              dataIndex: 'className',
              align: 'center',
              customRender: (_, record) => record.className || record?.classId_dictText || '',
            },
            {
              title: '学生',
              dataIndex: 'studentName',
              align: 'center',
              customRender: (_, record) => record.studentName || record?.studentId_dictText || '',
            },
            {
              title: '提醒时间',
              dataIndex: 'createTime',
              align: 'center',
            },
            {
              title: '提醒内容',
              dataIndex: 'comment',
              align: 'center',
              customCell: () => {
                return {
                  style: {
                    maxWidth: '800px',
                  },
                }
              },
            },
            {
              title: '当前环节',
              align: 'center',
              // 渲染函数：类似react中jsx的写法
              customRender: (_, record) => {
                return (
                  <div style="min-width: 100px;">
                    {this.handleWarningInfo(record.dataType, record.warnStatus)}
                  </div>
                )
              },
            },
            {
              title: '处理详情',
              dataIndex: 'action',
              align: 'center',
              scopedSlots: { customRender: 'action' },
            },
          ],
          tableData: [],
          loading: false,
          pagination: { ...tablePagination },
        },
        {
          tab: '班级提醒',
          key: 2,
          columns: [
            {
              title: '序号',
              dataIndex: 'index',
              align: 'center',
            },
            {
              title: '班级',
              dataIndex: 'name',
              align: 'center',
            },
            {
              title: '班主任',
              dataIndex: 'teacher_name',
              align: 'center',
            },
            {
              title: '提醒时间',
              dataIndex: 'dateStr',
              align: 'center',
            },
            {
              title: '提醒内容',
              dataIndex: 'COMMENT',
              align: 'center',
              customCell: () => {
                return {
                  style: {
                    maxWidth: '800px',
                  },
                }
              },
            },
            {
              title: '当前环节',
              align: 'center',
              customRender: (_, record) => {
                return (
                  <div style="min-width: 100px;">
                    {this.handleWarningInfo(record.data_type, record.warn_status)}
                  </div>
                )
              },
            },
            {
              title: '处理详情',
              dataIndex: 'action',
              align: 'center',
              scopedSlots: { customRender: 'action' },
            },
            ,
          ],
          tableData: [],
          loading: false,
          pagination: { ...tablePagination },
        },
        {
          tab: '心情记录',
          key: 3,
          columns: [
            {
              title: '#',
              align: 'center',
              dataIndex: 'index',
            },
            {
              title: '评论者名称',
              align: 'center',
              dataIndex: 'name',
            },
            {
              title: '评论者角色',
              align: 'center',
              dataIndex: 'title',
            },
            {
              title: '心情记录',
              align: 'center',
              dataIndex: 'ementScore',
              // 渲染函数：类似react中jsx的写法
              customRender: (_, record) => {
                return (
                  <span>
                    {record.ementScore == 1 ? '愉悦' : record.ementScore == 0 ? '正常' : '未知情绪'}
                  </span>
                )
              },
            },
            {
              title: '详细原因',
              align: 'center',
              dataIndex: 'comment',
              customCell: () => {
                return {
                  style: {
                    maxWidth: '800px',
                  },
                }
              },
            },
            {
              title: '原因分析',
              align: 'center',
              dataIndex: 'specialflag',
            },
            // {
            //   title: '情绪标签',
            //   align: 'center',
            //   dataIndex: '',
            // },
            {
              title: '评论时间',
              dataIndex: 'createTime',
              align: 'center',
            },
          ],
          tableData: [],
          loading: false,
          pagination: { ...tablePagination },
        },
      ],
      url: {
        list: '/rector/moodRecordAndWarnRecord',
        importExcelUrl: '',
        exportXlsUrl: '',
      },
      detailModalData: [],
      currStudentName: '',
    }
  },
  created() {
    this.loadData()
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    exportXls() {
      const exportData = []
      this.tabPaneConfig[this.tabKey - 1].tableData.forEach((data) => {
        var singleData = {}
        this.tabPaneConfig[this.tabKey - 1].columns.forEach((column) => {
          singleData[column.title] = data[column.dataIndex]
        })
        exportData.push(singleData)
      })

      console.log('导出的数据格式：', exportData)

      // 将数据转化为xlsx的表格数据结构
      const ws = XLSX.utils.json_to_sheet(exportData)

      // 设置列宽
      ws['!cols'] = [
        { wpx: 40 }, // 第一列宽度为40像素
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 200 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 200 },
      ]

      // 开启自动换行并设置居中
      for (let cell in ws) {
        if (cell[0] === '!') continue // 跳过特殊属性
        if (!ws[cell].s) ws[cell].s = {} // 确保样式对象存在
        ws[cell].s.alignment = {
          wrapText: true, // 自动换行
          horizontal: 'center', // 水平居中
          vertical: 'center', // 垂直居中
        }
      }

      // 新建工作簿并添加表格数据
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, '校园动态-心情记录')

      // 生成Excel文件并导出
      XLSX.writeFile(wb, '校园动态-心情记录列表.xlsx')
    },
    handleTabChange(key) {
      this.tabKey = key
      this.queryParam = {}
      this.detailModalData = []
      this.loadData()
    },
    // 分页变化
    handleTableChange(page) {
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'pagination', page)
      this.loadData()
    },
    onSelectChange(selectedRowKeys) {
      console.log('selectedRowKeys changed: ', selectedRowKeys)
      this.selectedRowKeys = selectedRowKeys
    },
    // 查询
    queryTable() {
      console.log('查询条件--', this.queryParam)
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'pagination', { ...tablePagination })
      this.loadData()
    },
    searchName: simpleDebounce(function (event) {
      const name = event.target.value
      this.getTableData({
        name,
        pageNo: 1,
        pageSize: name ? 100 : 10,
        type: 0,
        dataType: 1,
        userIdentity: 1,
      })
    }, 500),
    loadData() {
      let params = {
        pageNo: this.tabPaneConfig[this.tabKey - 1].pagination.current,
        pageSize: this.tabPaneConfig[this.tabKey - 1].pagination.pageSize,
      }
      switch (this.tabKey) {
        case 1:
          this.$set(this.url, 'list', '/rector/moodRecordAndWarnRecord')
          params = {
            ...params,
            dataType: 1,
            userIdentity: 1,
            type: this.queryParam.type || 0,
            name: this.queryParam.name || '',
          }
          break
        case 2:
          this.$set(this.url, 'list', '/psychology/classMindConfirm')
          params = { ...params, type: this.queryParam.type || 2 }
          break
        case 3:
          this.$set(this.url, 'list', '/rector/moodRecordAndWarnRecord')
          params = { ...params, dataType: 2, type: 0, userIdentity: 1 }
          break
      }
      this.getTableData(params)
    },
    getTableData(params) {
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'loading', true)
      getAction(this.url.list, params)
        .then((res) => {
          if (res.success) {
            const tableData = res.result.records.length
              ? res.result.records.map((item, index) => ({
                  ...item,
                  index: index + 1,
                }))
              : []
            this.$set(this.tabPaneConfig[this.tabKey - 1], 'tableData', tableData)
            this.$set(this.tabPaneConfig[this.tabKey - 1].pagination, 'total', res.result.total)
          }
        })
        .finally(() => {
          this.$set(this.tabPaneConfig[this.tabKey - 1], 'loading', false)
        })
    },
    handelDetail(record) {
      console.log('查看详情--', record)

      if (record?.discussList) {
        this.detailModalData = record.discussList
      }

      this.$refs.handleDetailModal.show(this.detailModalData)
    },
    // 处理提醒信息
    handleWarningInfo(dataType, status) {
      const warnList = {
        1: {
          0: '无流程',
          1: '待班主任确认',
          2: '预约心理老师',
          3: '心理老师确认',
          4: '学生签到',
          5: '学生签退',
          6: '上报',
          7: '班主任已跟进处理',
          99: '误报',
        },
        2: {
          0: '无流程',
          1: '待年级主任确认',
          2: '年级主任已跟进处理',
          3: '上报',
          99: '误报',
        },
      }
      const warnInfo = warnList?.[dataType]?.[status]
      return warnInfo ? warnInfo : '未知状态'
    },
  },
}
</script>
<style scoped lang="less">
.action-detail {
  min-width: 100px !important;
  color: #0077fa !important;
  cursor: pointer !important;
}
</style>
